const AppActions = {
  APP_READY: 'APP_READY',
};

// Backwards compatiblity for SystemActions
export { AppActions, AppActions as SystemActions };
